import Privacity from './Privacity';
export default Privacity;